import { render } from "./numerics-slot.vue?vue&type=template&id=8086f7b2&scoped=true"
import script from "./numerics-slot.vue?vue&type=script&lang=js"
export * from "./numerics-slot.vue?vue&type=script&lang=js"

import "./numerics-slot.vue?vue&type=style&index=0&id=8086f7b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8086f7b2"]])

export default __exports__